import { memo } from 'react'
import Box from './Box'
import GrooverText from './GrooverText'
import { getGrooverText } from '../libs/GrooverTextRepository'
import emptyActivity from '/public/emptyActivity.svg'
import emptyStateImage from '/public/emptyStateImage.svg'
import { Client } from '../../../pure-js/types/GrooverTypes'

const DeletedEnrollment = ({ client }: { client?: Client }) => {
  return (
    <Box fullWidth fullHeight align="center" justify="center">
      <img
        src={emptyActivity}
        width={375}
        height={150}
        alt={getGrooverText('userWeb.registration.deletedEnrollment.missingAlt')}
      />
      <img
        src={emptyStateImage}
        width={375}
        height={150}
        alt={getGrooverText('userWeb.registration.deletedEnrollment.emptyStateAlt')}
      />
      <Box top>
        <GrooverText textKey="adminGeneralInfoTextsDeletedEnrollmentInfo" />
        {client?.contactEmail}
      </Box>
    </Box>
  )
}

export default memo(DeletedEnrollment)
